import { useState } from 'react';
import useWidth from '../../../../../../../components/Hooks/useWidth';
import { useGetCatalog } from '../../../../../../../services/modules/catalogs/catalogs.queries';
import {
  CATALOG_DESKTOP_BANNER_DIMENSIONS,
  CATALOG_MOBILE_BANNER_DIMENSIONS,
} from '../../../../../creation/catalogCreationMedia.consts';
import useCanManageBrandCatalogs from '../../../../../hooks/useCanManageBrandCatalogs';

interface UseCatalogBannerParams {
  catalogId: string;
  isReadOnly: boolean;
  isOfflineMode?: boolean;
}

const useCatalogBanner = ({ catalogId, isReadOnly, isOfflineMode }: UseCatalogBannerParams) => {
  const { data: catalog } = useGetCatalog({ id: catalogId, isOfflineMode });
  const { mobileWidth } = useWidth();
  const canManageBrandCatalogs = useCanManageBrandCatalogs();

  const [isBannersModalOpen, setIsBannersModalOpen] = useState(false);

  const desktopBannerUrls = catalog?.ribbonBannerUrls ?? [];
  const mobileBannerUrls = catalog?.ribbonBannerMobileUrls ?? [];
  const bannerUrls = mobileWidth ? mobileBannerUrls : desktopBannerUrls;

  const { width, height } = mobileWidth
    ? CATALOG_MOBILE_BANNER_DIMENSIONS
    : CATALOG_DESKTOP_BANNER_DIMENSIONS;

  return {
    catalogName: catalog?.name ?? '',
    bannerUrls,
    hasAnyBanner: desktopBannerUrls.length + mobileBannerUrls.length > 0,
    bannerAspectRatio: String(width / height),
    canManageBanners: canManageBrandCatalogs && !isReadOnly,
    isBannersModalOpen,
    openBannersModal: () => setIsBannersModalOpen(true),
    closeBannersModal: () => setIsBannersModalOpen(false),
  };
};

export default useCatalogBanner;
